import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"
import Modal from '@mui/material/Modal';

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import Avatar from '@mui/material/Avatar';

import MenuItem from '@mui/material/MenuItem';


import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/commessa.json"
import { UPLOAD_PATH, STATUS_WORKER } from "constant.js";
import defaultUser from 'assets/images/default-user.png';

import * as ajax from "helpers/ajax";
import CalendarIcon from 'components/CalendarIcon'

import { filterEmptyWorkers, workerPriceByWorkType, isFestiveDay } from "../../helpers/functions";
import { ROLES } from "constant"

const monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

const weekNames=["Domenica","Lunedi","Martedi","Mercoledi","Giovedi","Venerdi","Sabato"]



export default class GestioneOperai extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCommessa: this.props.id,
            selectedDay:this.props.selectedDate?new Date(this.props.selectedDate):new Date(),
            selectedWorkerDay: null,

            listOperai: this.props.operai,
            listWorkingDays: [],
            listWorkingDaysAllCommessa:[],

            openModalWorkerOccupied:false,
            modalWorkerOccupied: null,

            nameFilter:"",
        }

        this.refCalendar = null;
    }

    componentDidMount = () => {
        this.loadWorkingDay();
        document.addEventListener("keydown", this._handleDocumentClick, false);
    }

    _handleDocumentClick = (e) => {
        if (this.state.selectedWorkerDay != null && this.saveButton && e.key=="Enter" ) {
            this.saveButton.click()
        }
    }


    renderListaOperai = () => {
        let arr = [];
        let list = this.state.listOperai

        list = list.filter(list => (list.nome.toLowerCase().includes(this.state.nameFilter.toLowerCase()) || list.cognome.toLowerCase().includes(this.state.nameFilter.toLowerCase()) || list.mansione.toLowerCase().includes(this.state.nameFilter.toLowerCase()) ));

        let listOrdered = [];

        list.map((el) => {

            if (this.state.listWorkingDaysAllCommessa.some(e => e.operaio.id === el.id)) {
                el["exist"] = true
                listOrdered.push(el)
            } else {
                el["exist"] = false
                listOrdered.unshift(el)
            }
        })


        listOrdered.map((el, index) => {
            arr.push(
                <Grid container alignItems={"center"} my={1} p={1} key={"list-operai-" + index} sx={{ backgroundColor: (el.exist)?"#cccccc80":"transparent", borderRadius:2 }}>
                    <Grid item sm={6} >
                        <Grid container alignItems={"center"}>
                            <Grid item mr={2}>
                                <Avatar src={UPLOAD_PATH + "/file/operai/" + el.id + ".png"} size={"xs"} alt={el.nome.toUpperCase()} sx={{ width: 24, height: 24 }} />
                            </Grid>
                            <Grid item>
                                <MDTypography variant={"caption"}>{el.nome}{" "}{el.cognome}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={5}>
                        <MDTypography variant={"caption"}>{el.mansione}</MDTypography>
                    </Grid>
                    {[ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo) ? null :
                        <Grid item sm={1}>
                            <MDButton variant="gradient" color="success" iconOnly size={"small"} onClick={() => this.addWorker(el.id, false, el)}>
                                <Icon>add</Icon>
                            </MDButton>
                        </Grid>
                    }
                </Grid>
            )
        })

        return arr
    }

    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }


    changeMonth = (n) => {
        let date = this.state.selectedDay
        date.setMonth(date.getMonth() + n);
        this.setState({ selectedDay: date }, this.loadWorkingDay)
        this.setintelCalendarDate(date)
    }

    changeDay = (n) => {
        let date = this.state.selectedDay
        date.setDate(date.getDate() + n);
        this.setState({ selectedDay: date }, this.loadWorkingDay)
        this.setintelCalendarDate(date)
    }

    setintelCalendarDate = (date) => {
        let day = date.getDate();
        let month = date.getMonth()+1;
        let year = date.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }

        if (month < 10) {
            month = `0${month}`;
        }

        let output = year + "-" + month + "-" + day;
        this.refCalendar.setDate(output)

    }

    setDate = (val) => {
        let date = new Date(val)
        this.setState({ selectedDay: date }, this.loadWorkingDay)
    }

    loadWorkingDay = () => {
        this.props.setDateCallback(this.state.selectedDay)
        ajax.ajaxGetStrapi("operai-commesses?populate=*&filters[data][$eq]=" + this.convertDate(this.state.selectedDay) + "&filters[commessa][id][$eq]=" + this.state.selectedCommessa, this.loadListWorkingDay)
        ajax.ajaxGetStrapi("operai-commesses?populate=*&filters[data][$eq]=" + this.convertDate(this.state.selectedDay), this.loadListWorkingDayAllCommessa)
    }

    loadListWorkingDay = (response) => {
        this.setState({ listWorkingDays: filterEmptyWorkers(response.data) })
    }

    loadListWorkingDayAllCommessa = (response) => {
        this.setState({ listWorkingDaysAllCommessa: filterEmptyWorkers(response.data) })
    }

    addWorker = (id, force = false, worker) => {
        if (!force) {
            if (this.state.listWorkingDaysAllCommessa.some(e => e.operaio.id === id)) {
                this.setState({ openModalWorkerOccupied: id, modalWorkerOccupied:worker })
                return
            }
        } else {
            // If force is true, reset filler to 0 for existing workers on the same day
            this.state.listWorkingDaysAllCommessa.forEach(existingWorker => {
                if (existingWorker.operaio.id === id) {
                    const updateData = {
                        data: { filler: 0 }
                    };
                    ajax.ajaxPutStrapi(`operai-commesses/${existingWorker.id}`, updateData, (response) => {
                        // Update global workers data
                        const workerIndex = global.workers.data.findIndex(w => w.id === existingWorker.id);
                        if (workerIndex !== -1) {
                            global.workers.data[workerIndex].filler = 0;
                        }
                    });
                }
            });
        }

        // Controllo se il giorno selezionato è festivo
        const festiveDays = ["01/01", "12/25", "12/31", "04/25", "05/01", "06/02", "06/29"];
        const isFestivo = isFestiveDay(this.state.selectedDay, festiveDays);
        
        let data = {
            data: {
                operaio: id,
                commessa: this.state.selectedCommessa,
                ore: 8,
                data: this.state.selectedDay,
                stato: isFestivo ? "STRAORDINARI " : "ORDINARIO",
                costo_orario: isFestivo ? workerPriceByWorkType("STRAORDINARI ", worker) : worker.costo_orario
            }
        }

        ajax.ajaxPostStrapi("operai-commesses", data, this.workerAdded)
    }

    workerAdded = (response) => {
        this.loadWorkingDay()
        ajax.ajaxGetStrapi("operai-commesses?populate[commessa][fields][0]=nome&populate=operaio&filters[id][$eq]=" + response.data.id, (workerResponse) => {
            global.workers.data.push(workerResponse.data[0]);
            // Notify parent component of the update
            if (this.props.onWorkerUpdate) {
                this.props.onWorkerUpdate();
            }
        })
    }

    renderCalendar = () => {
        return (
            <>
                <Grid container justifyContent={"space-between"} alignItems={"center"} >
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(-1)}><Icon>keyboard_double_arrow_left</Icon></MDButton>
                    </Grid>
                    <Grid item>
                        <MDTypography variant={"h3"} mr={2}>
                            <CalendarIcon onChange={(val) => this.setDate(val)} style={{ verticalAlign: "middle" }} ref={(ref) => this.refCalendar = ref}/>
                            {monthNames[this.state.selectedDay.getMonth()]}{" "}{this.state.selectedDay.getFullYear()}
                        </MDTypography>
                    </Grid>
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(1)}><Icon>keyboard_double_arrow_right</Icon></MDButton>
                    </Grid>
                </Grid>

                <Grid container justifyContent={"space-between"} alignItems={"center"} px={5}  >
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeDay(-1)}><Icon>keyboard_arrow_left</Icon></MDButton>
                    </Grid>
                    <Grid item>
                        <MDTypography variant={"h5"} mr={2}>{weekNames[this.state.selectedDay.getDay()]}{", "}{this.state.selectedDay.getDate()}</MDTypography>
                    </Grid>
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeDay(1)}><Icon>keyboard_arrow_right</Icon></MDButton>
                    </Grid>
                </Grid>

                <Grid container>
                    {this.renderWorkerInCalendar()}
                </Grid>
            </>
        );
    }

    renderWorkerInCalendar = () => {
        let arr = [];
        this.state.listWorkingDays.map((el, index) => {
            if (!el.operaio) { return }
            arr.push(
                <Grid item key={"worker-day-" + index} mb={1} mr={1}>

                    <MDButton color="info" size="small" onClick={() => {
                        if (![ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo)) {
                            this.setState({ selectedWorkerDay: el })
                        }
                    }}>
                        {el.operaio.nome} {el.operaio.cognome} , {el.ore}H, {el.stato}
                    </MDButton>
                </Grid>
            )

            if(el.filler){
                if (el.filler > 0) {
                                arr.push(
                <Grid item key={"worker-day-" + index} mb={1} mr={1}>
                    <MDButton color="primary" size="small" onClick={() => {
                        if (![ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo)) {
                            this.setState({ selectedWorkerDay: el })
                        }
                    }}>
                        {el.operaio.nome} {el.operaio.cognome} , {el.filler}H, {"ORDINARIO"}
                    </MDButton>
                </Grid>
            )}

            }
        })
        return arr;
    }


    deleteWorkerDay = () => {
        ajax.ajaxDeleteStrapi("operai-commesses/" + this.state.selectedWorkerDay.id, this.deleteSaveCallback)
    }

    saveWorkerDay = () => {
        let data = {
            data: {
                stato: this.state.selectedWorkerDay.stato,
                ore: this.state.selectedWorkerDay.ore,
                note: this.state.selectedWorkerDay.note,
                costo_orario: this.state.selectedWorkerDay.costo_orario,
                filler: (this.state.selectedWorkerDay.filler>0)?Math.max(0, 8 - this.state.selectedWorkerDay.ore):0
            }
        }
        
        // Update global workers data
        const workerIndex = global.workers.data.findIndex(w => w.id === this.state.selectedWorkerDay.id);
        if (workerIndex !== -1) {
            global.workers.data[workerIndex] = { ...global.workers.data[workerIndex], ...data.data };
        }
        
        ajax.ajaxPutStrapi("operai-commesses/" + this.state.selectedWorkerDay.id, data, (response) => {
            // Notify parent component of the update
            if (this.props.onWorkerUpdate) {
                this.props.onWorkerUpdate();
            }
            this.deleteSaveCallback(response);
        })
    }

    deleteSaveCallback = (response) => {
        this.setState({ selectedWorkerDay: null }, this.loadWorkingDay)
    }

    occupiedWorkerList = () => {
        let arr = {}

        this.state.listWorkingDaysAllCommessa.filter(e => e.operaio.id === this.state.openModalWorkerOccupied).map((el) => {
            if (!arr[el.commessa.nome]) {
                arr[el.commessa.nome] = {
                    id:el.commessa.id,
                    ord: 0,
                    str: 0,
                    perm: 0,
                    ferie: 0,
                    malat: 0,
                    ass: 0,
                    sosp: 0,
                    nott: 0,
                    pm: 0,
                }
            } 
            if (el.stato == "ORDINARIO") { arr[el.commessa.nome].ord += el.ore }
            if (el.stato == "STRAORDINARI ") { arr[el.commessa.nome].str += el.ore }
            if (el.stato == "PERMESSO") { arr[el.commessa.nome].perm += el.ore }
            if (el.stato == "FERIE") { arr[el.commessa.nome].ferie += el.ore }
            if (el.stato == "MALATTIA") { arr[el.commessa.nome].malat += el.ore }
            if (el.stato == "ASSENZA") { arr[el.commessa.nome].ass += el.ore }
            if (el.stato == "SOSPESO") { arr[el.commessa.nome].sosp += el.ore }
            if (el.stato == "NOTTURNO") { arr[el.commessa.nome].nott += el.ore }
            if (el.stato == "PATERNITA/MATERNITA") { arr[el.commessa.nome].pm += el.ore }
        })

        let temp = [];
        for (const [key, value] of Object.entries(arr)) {
            temp.push({
                commessa: key,
                commessa_id: value.id,
                ord: value.ord,
                str: value.str,
                perm: value.perm,
                ferie: value.ferie,
                malat: value.malat,
                ass: value.ass,
                sosp: value.sosp,
                nott: value.nott,
                pm: value.pm,
            })
        }


        return temp
    }

    render() {
        return (
            <>

                <Grid container mt={5}>
                    <Grid item sm={12} md={6} pr={2}>
                        <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                            <MDInput type="search" fullWidth label="Cerca" onChange={(e) => { this.setState({ nameFilter: e.target.value }) }} />
                            {this.renderListaOperai()}
                        </MDBox>
                    </Grid>
                    <Grid item sm={12} md={6} pl={2}>
                        <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                            {this.renderCalendar()}
                        </MDBox>
                    </Grid>
                </Grid>


                {this.state.selectedWorkerDay != null ?

                    <Modal
                        open={this.state.selectedWorkerDay != null}
                        onClose={() => this.setState({ selectedWorkerDay: null })}
                        style={{
                            margin: "auto", display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                    >
                        <MDBox
                            bgColor={"white"}
                            borderRadius="lg"
                            p={2}
                            minWidth={400}
                        >
                            <MDBox
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                mx={2}
                                mt={-3}
                                p={2}
                                mb={1}
                                textAlign="center"
                            >
                                <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                                    Modifica Assegnazione
                            </MDTypography>
                            </MDBox>

                            <Grid container={true} >
                                <Grid item sm={12} mb={2}>
                                    <MDInput fullWidth readOnly variant="standard" value={this.state.selectedWorkerDay.operaio.nome + " " + this.state.selectedWorkerDay.operaio.cognome} />
                                </Grid>
                                <Grid item sm={12} mb={2}>
                                    <MDInput
                                        value={this.state.selectedWorkerDay.stato}
                                        select
                                        fullWidth
                                        label={"Stato"}
                                        onChange={(e) => {
                                            const nuovoStato = e.target.value;
                                            const operaio = this.state.selectedWorkerDay.operaio;
                                            
                                            // Calcola il nuovo costo_orario in base allo stato
                                            let nuovoCosto = workerPriceByWorkType(nuovoStato, operaio);
                                            
                                            this.setState(prevState => ({
                                                selectedWorkerDay: {
                                                    ...prevState.selectedWorkerDay,
                                                    stato: nuovoStato,
                                                    costo_orario: nuovoCosto
                                                }
                                            }))
                                        }}
                                    >
                                        {STATUS_WORKER.map((val, i) => {
                                            return (
                                                <MenuItem value={val} key={"select-status" + i}>{val}</MenuItem>
                                            )
                                        })}
                                    </MDInput>
                                </Grid>
                                <Grid item sm={12} mb={2}>
                                    <MDInput
                                        value={this.state.selectedWorkerDay.ore}
                                        fullWidth
                                        label={"Ore"}
                                        type={"number"}
                                        min={1}
                                        max={12}
                                        onChange={(e) => {
                                            this.setState(prevState => ({
                                                selectedWorkerDay: {
                                                    ...prevState.selectedWorkerDay,
                                                    ore: e.target.value
                                                }
                                            }))
                                        }}
                                    />
                                </Grid>
                                <Grid item sm={12} mb={2}>
                                    <MDInput
                                        value={this.state.selectedWorkerDay.note}
                                        fullWidth
                                        label={"Note"}
                                        type={"text"}
                                        multiline={true}
                                        onChange={(e) => {
                                            this.setState(prevState => ({
                                                selectedWorkerDay: {
                                                    ...prevState.selectedWorkerDay,
                                                    note: e.target.value
                                                }
                                            }))
                                        }}
                                    />
                                </Grid>
                                {global.user.ruolo === ROLES.admin ?
                                    <Grid item sm={12} mb={2}>
                                        <MDInput
                                            value={this.state.selectedWorkerDay.costo_orario || ""}
                                            fullWidth
                                            label={"Costo Orario (€/h)"}
                                            type={"number"}
                                            readOnly
                                            variant="standard"
                                        />
                                    </Grid>
                                    : null}

                            </Grid>

                            <Grid container>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="error" onClick={() => this.deleteWorkerDay()}>
                                        <Icon style={{ marginRight: 10 }}>delete</Icon>
                                        elimina
                                </MDButton>
                                </Grid>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="success" ref={(ref) => this.saveButton = ref} onClick={() => this.saveWorkerDay()}>
                                        <Icon style={{ marginRight: 10 }}>add</Icon>
                                        Salva
                                </MDButton>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Modal>
                    : null
                }


                <Modal
                    open={this.state.openModalWorkerOccupied}
                    onClose={() => this.setState({ openModalWorkerOccupied: false })}
                    style={{
                        margin: "auto", display: "flex", alignItems: "center", justifyContent: "center"
                    }}
                >
                    <MDBox
                        bgColor={"white"}
                        borderRadius="lg"
                        p={2}
                        minWidth={400}
                        maxWidth={1200}
                    >
                        <MDBox
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                            mx={2}
                            mt={-3}
                            p={2}
                            mb={1}
                            textAlign="center"
                        >
                            <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                                OPERAIO OCCUPATO
                            </MDTypography>
                        </MDBox>

                        <Grid container>
                            <Grid item sm={12} p={2}>
                                <MDTypography variant="body2" mt={2} mb={2}>
                                    Questo operaio è gia associatio ad un cantiere per il giorno selezionato, sicuro di volerlo aggiungere?
                                </MDTypography>
                            </Grid>
                            <Grid item sm={12} p={2}>

                                <Grid container>
                                    <Grid item sm={2}><MDTypography variant="body2" fontWeight="medium">CANTIERE</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>ORD.</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>STRA.</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>PERM.</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>FERIE</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>MALAT.</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>ASS.</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>SOSP.</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>NOTT.</MDTypography></Grid>
                                    <Grid item sm={1}><MDTypography variant="body2" fontWeight="medium" style={{ textAlign: "center" }}>P/M</MDTypography></Grid>
                                    <Grid item sm={1}></Grid>
                                </Grid>

                                {
                                }

                                {this.occupiedWorkerList().map((el) => {

                                    return (
                                        <Grid container style={{ borderTop: "1px solid #CCCCCC80", alignItems:"center"}}>
                                            <Grid item sm={2}><MDTypography variant="body2">{el.commessa}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.ord}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.str}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.perm}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.ferie}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.malat}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.ass}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.sosp}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.nott}</MDTypography></Grid>
                                            <Grid item sm={1}><MDTypography variant="body2" style={{ textAlign: "center" }}>{el.pm}</MDTypography></Grid>
                                            <Grid item sm={1} style={{textAlign:"right"}}>
                                                <MDButton variant="gradient" color="success" iconOnly size={"small"} onClick={() => { this.props.changeCommessa(el.commessa, el.commessa_id); this.setState({ openModalWorkerOccupied: false })}}>
                                                    <Icon>visibility</Icon>
                                                </MDButton>
                                            </Grid>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs pr={1}>
                                <MDButton fullWidth color="error" onClick={() => this.setState({ openModalWorkerOccupied: false, modalWorkerOccupied:null })}>
                                    <Icon style={{ marginRight: 10 }}>delete</Icon>
                                    ANNULLA
                                </MDButton>
                            </Grid>
                            <Grid item xs pr={1}>
                                <MDButton fullWidth color="success" onClick={() => { this.addWorker(this.state.openModalWorkerOccupied, true, this.state.modalWorkerOccupied); this.setState({ openModalWorkerOccupied: false, modalWorkerOccupied:null }) }}>
                                    <Icon style={{ marginRight: 10 }}>add</Icon>
                                    AGGIUNGI
                                </MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Modal>

            </>
        )
    }
}




GestioneOperai.defaultProps = {
    onWorkerUpdate: null
}
